import './timeWindow.scss'
import { useEffect, useState } from 'react'
import NumberInput from '../numberInput/numberInput'
import SelectSingle from '../selectSingle/selectSingle'
import CheckboxItem from '../checkbox/checkbox'
import { Box, InputLabel, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const TimeWindow = ({
  propertie,
  ruleParameters,
  setRuleParameters,
  granularity,
  desc,
  schema,
  setError,
  errorList,
  setErrorList,
  isEditing,
}) => {
  const [finalParameter, setFinalParameter] = useState({})
  const [change, setChange] = useState(false)
  const { t } = useTranslation(['common'])

  useEffect(() => {
    if (ruleParameters[propertie] && Object.keys(finalParameter).length === 0) {
      setFinalParameter({ ...ruleParameters[propertie] })
    }
  }, [propertie, ruleParameters, finalParameter])

  const hangleChange = (value) => {
    if (value.granularity === 'Calendar Date') value.rollingBasis = false
    setFinalParameter(value)
    setChange(true)
  }
  const isRollingBasisDisabled = finalParameter.granularity === 'Calendar Date'

  useEffect(() => {
    let errors = []
    if (!finalParameter.granularity) errors.push(`${t('rules:granularity')} ${t('common:isRequired')}`)
    if (!finalParameter.units && finalParameter.units !== 0) errors.push(`${t('rules:units')} ${t('common:isRequired')}`)
    if (errors.length !== 0) {
      let all = errorList
      all[propertie] = errors
      setErrorList({ ...all })
      setError(true)
    } else {
      let all = errorList
      delete all[propertie]
      setErrorList({ ...all })
      setError(false)
    }

    if (change) {
      let all = { ...ruleParameters }
      all[propertie] = finalParameter
      setRuleParameters({ ...all })
      setChange(false)
    }
  }, [change, finalParameter])

  return (
    <Box className="window-input-container">
      <Box className="window-input-row">
        <Box className="window-label">
          <Typography variant="title3">{t('common:timeGranularity')}</Typography>
        </Box>
        {granularity && (
          <SelectSingle
            isEditing={isEditing}
            propertie={'granularity'}
            ruleParameters={finalParameter}
            setRuleParameters={hangleChange}
            posibleValues={granularity}
            translateValues={true}
          />
        )}
      </Box>

      <Box className="window-input-row">
        <Box className="window-label">
          <Typography variant="title3">{t('common:numberOfTimeUnit')}</Typography>
        </Box>
        <NumberInput
          isEditing={isEditing}
          propertie={'units'}
          ruleParameters={finalParameter}
          setRuleParameters={hangleChange}
          schema={schema}
        />
      </Box>

      <CheckboxItem
        isEditing={isEditing}
        propertie={'rollingBasis'}
        ruleParameters={finalParameter}
        setRuleParameters={hangleChange}
        label={'rollingBasis'}
        text={desc}
        disabled={isRollingBasisDisabled}
      />
    </Box>
  )
}

export default TimeWindow
